module.exports = __webpack_public_path__ + "img/glassquality_7.1eee4f9e.png";